import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOrganisationInfoQueryVariables = Types.Exact<{
  uuid: Types.Scalars['String']['input'];
}>;


export type GetOrganisationInfoQuery = { __typename?: 'Query', organisation: { __typename?: 'Organisation', id: string, uuid: string, name: string } };


export const GetOrganisationInfoDocument = gql`
    query GetOrganisationInfo($uuid: String!) {
  organisation(uuid: $uuid) {
    id
    uuid
    name
  }
}
    `;

/**
 * __useGetOrganisationInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganisationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationInfoQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetOrganisationInfoQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationInfoQuery, GetOrganisationInfoQueryVariables> & ({ variables: GetOrganisationInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationInfoQuery, GetOrganisationInfoQueryVariables>(GetOrganisationInfoDocument, options);
      }
export function useGetOrganisationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationInfoQuery, GetOrganisationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationInfoQuery, GetOrganisationInfoQueryVariables>(GetOrganisationInfoDocument, options);
        }
// @ts-ignore
export function useGetOrganisationInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationInfoQuery, GetOrganisationInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationInfoQuery, GetOrganisationInfoQueryVariables>;
export function useGetOrganisationInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationInfoQuery, GetOrganisationInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationInfoQuery | undefined, GetOrganisationInfoQueryVariables>;
export function useGetOrganisationInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationInfoQuery, GetOrganisationInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationInfoQuery, GetOrganisationInfoQueryVariables>(GetOrganisationInfoDocument, options);
        }
export type GetOrganisationInfoQueryHookResult = ReturnType<typeof useGetOrganisationInfoQuery>;
export type GetOrganisationInfoLazyQueryHookResult = ReturnType<typeof useGetOrganisationInfoLazyQuery>;
export type GetOrganisationInfoSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationInfoSuspenseQuery>;
export type GetOrganisationInfoQueryResult = Apollo.QueryResult<GetOrganisationInfoQuery, GetOrganisationInfoQueryVariables>;